module.exports = __webpack_public_path__ + "public/images/painting-background-pattern.d938bb99cfd2c3d5f10c7640decab4e0.svg";